import { FaPiggyBank } from "react-icons/fa";
import { defineField, defineType } from "sanity";
import { imageWithAlt } from "../objects";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "microContentSubscribeToNewsletter",
  title: "Subscribe to Newsletter",
  description: "Content for the SFO",
  icon: FaPiggyBank,
  type: "document",
  groups: [
    {
      name: "content",
      title: "Content"
    },
    {
      name: "customPromo",
      title: "Custom Promo"
    }
  ],

  fields: [
    defineField({
      name: "heading",
      type: "blockContentTitleAndContent",
      group: "content"
    }),
    {
      title: "background image",
      name: "backgroundImage",
      type: imageWithAlt.name,
      group: "content"
    },
    {
      title: "Custom Promo",
      name: "promoConfiguration",
      type: "reference",
      to: [{ type: "promoConfiguration" }],
      group: "customPromo"
    },
    {
      title: "Custom Promo Heading",
      name: "customPromoHeading",
      type: "blockContentTitleAndContent",
      group: "customPromo"
    },
    {
      title: "footer content",
      name: "footerContent",
      type: "multilingualArrayBlockContent",
      group: "customPromo"
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare(value) {
      return {
        title: multilingualStringPreview(value.title),
        subtitle: "Subscribe to Newsletter"
      };
    }
  }
});
